import { render } from "./StartShoppingSection.vue?vue&type=template&id=194007ea&scoped=true"
import script from "./StartShoppingSection.vue?vue&type=script&lang=js"
export * from "./StartShoppingSection.vue?vue&type=script&lang=js"

import "./StartShoppingSection.vue?vue&type=style&index=0&id=194007ea&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-194007ea"]])

export default __exports__